// Shared booking colour system + date helpers, used by the Bookings list
// (highlight ring) and the Booking Calendar page (dots / event chips).

export const STATUS_COLOR = {
  confirmed:        { label: 'Confirmed', dot: 'bg-emerald-500', chip: 'border-emerald-200 bg-emerald-50 text-emerald-700 hover:bg-emerald-100', bar: 'bg-emerald-500', ring: 'ring-emerald-400' },
  completed:        { label: 'Completed', dot: 'bg-indigo-500',  chip: 'border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100',    bar: 'bg-indigo-500',  ring: 'ring-indigo-400' },
  cancelled:        { label: 'Cancelled', dot: 'bg-rose-500',    chip: 'border-rose-200 bg-rose-50 text-rose-600 line-through decoration-rose-300 hover:bg-rose-100', bar: 'bg-rose-500', ring: 'ring-rose-400' },
  hold:             { label: 'On hold',   dot: 'bg-amber-500',   chip: 'border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100',        bar: 'bg-amber-500',   ring: 'ring-amber-400' },
  awaiting_payment: { label: 'Awaiting',  dot: 'bg-amber-500',   chip: 'border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100',        bar: 'bg-amber-500',   ring: 'ring-amber-400' },
  pending:          { label: 'Pending',   dot: 'bg-slate-400',   chip: 'border-slate-200 bg-slate-50 text-slate-600 hover:bg-slate-100',        bar: 'bg-slate-400',   ring: 'ring-slate-400' },
};

export const colorOf = (status) => STATUS_COLOR[status] || STATUS_COLOR.pending;

export const tzOf = (b) => b.invitee_timezone || 'Asia/Kolkata';

// Local calendar date (YYYY-MM-DD) of a booking, in the invitee's timezone.
// Guarded so a single malformed booking (missing start_utc, bad timezone)
// can't throw and white-screen the whole calendar.
export const dayKeyOf = (b) => {
  const d = new Date(b?.start_utc);
  if (isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat('en-CA', { timeZone: tzOf(b), year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  } catch {
    return new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  }
};

export const timeLabelOf = (b) => {
  const d = new Date(b?.start_utc);
  if (isNaN(d.getTime())) return '';
  try {
    return new Intl.DateTimeFormat('en-US', { timeZone: tzOf(b), hour: 'numeric', minute: '2-digit' }).format(d);
  } catch {
    return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' }).format(d);
  }
};
